// @flow
import * as React from 'react';
import FutureJob from '../protocol/FutureJob';
import CreateFolderJob from '../upload/CreateFolderJob';
import Upload from '../upload/Upload';
import UploadingError from '../dnd/UploadingError';
import t from '../i18n/I18n';
import { ThemeSetup } from '../themes/ThemeSetup';
import './Uploading.css';

export function getUploadObjectForFolder(job: CreateFolderJob) {
  return {
    isFolder: true,
    name: job.name,
    progress: job.done ? 1 : 0,
    total: 1,
    status: job.done ? 'FINISHED' : job.canceled ? 'ERROR' : 'UPLOADING',
    errorText: job.canceled ? 'Canceled' : '',
    preview: ThemeSetup.getImageURL('folder.svg'),
    type: 'image'
  };
}

type Props = {
  job: FutureJob,
  uploadedLabel: any,
  uploadingHeight: number,
  deleteFileOnRemote: Function,
  onUploadComplete: Function
};

export default class Uploading extends React.Component<Props, {}> {
  _node: ?HTMLLIElement;

  componentDidMount() {
    const { job } = this.props;
    job.addListener('change', this.onChange);
    job.promise.then(this.onChange).catch(this.onChange);
  }

  componentWillUnmount() {
    const { job } = this.props;
    job.removeListener('change', this.onChange);
  }

  onChange = () => {
    const { job } = this.props;
    if (job.done) {
      this.props.onUploadComplete(job);
    }

    if (this._node) {
      this.forceUpdate();
    }
  };

  render() {
    const { job, uploadedLabel, deleteFileOnRemote } = this.props;
    const upload: Upload = job.upload || getUploadObjectForFolder(job);

    var progress = Math.floor((upload.loaded / upload.total) * 100) || 0;

    var statusMarkup;
    if (upload.status == 'FINISHED')
      statusMarkup = (
        <div className="finished">
          <span>{t('FINISHED_LABEL')}</span>
        </div>
      );
    if (upload.status == 'ERROR') statusMarkup = <UploadingError top={16} left={0} text={upload.errorText} />;
    // if (upload.status == 'UPLOADED') statusMarkup = uploadedLabel;
    if (upload.status == 'UPLOADED')
      statusMarkup = (
        <div style={{ width: '90%' }}>
          <p className="processingText">{t('PROCESSING')}...</p>
          <div className="uploadingLoader" />
        </div>
      );
    if (upload.status == 'UPLOADING')
      statusMarkup = (
        <div className="loading">
          <div className="progress-bar">
            <div style={{ width: `${progress}%` }} />
          </div>
          <div className="progress-text">{progress}%</div>
        </div>
      );

    let style = {
      maxWidth: this.props.uploadingHeight - 20
    };

    if (upload.preview) {
      style.backgroundImage = `url(${upload.preview})`;
      if (upload.isFolder) {
        style.backgroundSize = 'contain';
        style.height = '70%';
      }
    }

    const isImage = upload.type.indexOf('image') > -1;

    return (
      <li name="Uploading" ref={(node) => (this._node = node)}>
        <div className={isImage ? 'preview' : 'mock'} style={style} />
        <div className="upload-name">{upload.name}</div>
        <div className="upload-status">{statusMarkup}</div>
        {upload.status == 'UPLOADING' ? (
          <div className="trash" onClick={() => deleteFileOnRemote(job)} />
        ) : (
          <div className="" />
        )}
      </li>
    );
  }
}
